import "es6-promise/auto";
console.log("store promise");
import Vue from "vue";
import Vuex from "vuex";

import FireStoreParser from "firestore-parser";
import axios from "axios";

// Pro db
import dbPro from "@/config/pro/dbInit";
import { storage } from "@/config/pro/dbInit";
import { firestorePro } from "@/config/pro/dbInit";

const ENV = "pro";
const RUTA =
  ENV == "pro"
    ? "https://webs.janto.es"
    : "https://tomcatdesarrollos.janto.es:8443";
const CONTEXTO = ENV == "pro" ? "Janto_KB" : "Janto_DES";

const BONO_ID = "f4tux";
const BONOS_URL = `https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents/bonos/${BONO_ID}`;
// .collection('literales').doc('locale')
const LITERALES_URL = `https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents/bonos/${BONO_ID}/literales/locale`;

const establecimientosRef = dbPro.collection("gestion").doc("establecimientos");

const CONFIG_WEB = {
  araba: "8o4sf",
  bizkaia: "03m74",
  gipuzkoa: "23szur",
  home: "f4tux",
};

const CONFIG_CONSUMO = {
  araba: "w9ega",
  bizkaia: "w9ega",
  gipuzkoa: "w9ega",
  home: "w9ega",
  denda: "w9ega",
};

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    bonoActual: {},
    config: CONFIG_WEB,
    img1:
      "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/establecimientos%2Flogos%2Fhash%2Fimg-denda.svg?alt=media&token=e548bf12-2b44-434e-b9b1-f457678befe3",
    img2:
      "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/establecimientos%2Flogos%2Fimagen_bonos.svg?alt=media&token=19c0c36a-e0fb-44c3-824e-ea2bcc7a6709",
    establecimientoActual: {
      RazonSocial: "",
      Nombre: "",
      Contacto: "",
      SectorActividad: "",
      Descripcion: "",
      NumeroEmpleados: "",
      IAE: "",
      CIF: "",
      Direccion: "",
      CP: "",
      Poblacion: "",
      PersonaContacto: "",
      Cargo: "",
      EMail: "",
      Telefono: "",
      Web: "",
      NombreAsociacion: "",
      IBAN: "",
      UrlImagen: "",
      UrlDni: "",
      UrlCertificado: "",
      UrlIAE: "",
      Pais: "",
      Lat: "",
      Lng: "",
      IdGoogle: "",
      Provincia: "",
      DireccionGoogle: "",
      TipoBono: "",
      multi: "",
    },
    resetEstablecimiento: {
      RazonSocial: "",
      Nombre: "",
      Contacto: "",
      SectorActividad: "",
      Descripcion: "",
      NumeroEmpleados: "",
      IAE: "",
      CIF: "",
      Direccion: "",
      CP: "",
      Poblacion: "",
      PersonaContacto: "",
      Cargo: "",
      EMail: "",
      Telefono: "",
      Web: "",
      NombreAsociacion: "",
      IBAN: "",
      UrlImagen: "",
      UrlDni: "",
      UrlCertificado: "",
      UrlIAE: "",
      Pais: "",
      Lat: "",
      Lng: "",
      IdGoogle: "",
      Provincia: "",
      DireccionGoogle: "",
      TipoBono: "",
      multi: "",
    },
    direcconActual: {},
    menu: false,
    currentUpload: null,
    uploadProgress: null,
    uploadingImage: false,
    currentUpload: null,
    UrlImagen: null,
    UrlCertificado: null,
    UrlDni: null,
    UrlIAE: null,
    bonoActual: {},
    idOrigen: 7,
    idCampana: 7,
    idEstablecimientoActual: "",
    bonoName: "home",
    SectorActividad: [],
    IAE: [],
    TipoBono: [],
    slug: "",
    ventaActiva: false,
  },
  mutations: {
    establecimientoActual(state, payload) {
      state.establecimientoActual = payload;
    },
    bonoActual(state, payload) {
      state.bonoActual = payload;
    },
    menu(state, payload) {
      state.menu = payload;
    },
    direccionActual(state, payload) {
      state.direccionActual = payload;
    },
    uploadingImage(state, payload) {
      state.uploadingImage = payload;
    },
    uploadProgress(state, payload) {
      state.uploadProgress = payload;
    },
    currentUpload(state, payload) {
      state.currentUpload = payload;
    },
    UrlImagen(state, payload) {
      state.establecimientoActual.UrlImagen = payload;
      state.UrlImagen = payload;
    },
    UrlCertificado(state, payload) {
      state.establecimientoActual.UrlCertificado = payload;
      state.UrlCertificado = payload;
    },
    UrlDni(state, payload) {
      state.establecimientoActual.UrlDni = payload;
      state.UrlDni = payload;
    },
    UrlIAE(state, payload) {
      state.establecimientoActual.UrlIAE = payload;
      state.UrlIAE = payload;
    },
    bonoActual(state, payload) {
      state.bonoActual = payload;
    },
    idEstablecimientoActual(state, payload) {
      state.idEstablecimientoActual = payload;
    },
    bonoName(state, payload) {
      state.bonoName = payload;
    },
    IAE(state, payload) {
      state.IAE = payload;
    },
    SectorActividad(state, payload) {
      state.SectorActividad = payload;
    },
    TipoBono(state, payload) {
      state.TipoBono = payload;
    },
    slug(state, payload) {
      state.slug = payload;
    },
    ventaActiva(state, payload) {
      state.ventaActiva = payload;
    },
  },
  actions: {
    async insertarCompleto({ commit, state }, Peticion) {
      const idOrigen = state.idOrigen;
      const url = `${RUTA}/${CONTEXTO}/Operaciones?xmlDoc=
      <Operacion>
      <IdCookie>9999999999</IdCookie>
      <IdCookieUsuario>9999999999</IdCookieUsuario>
      <Usuario>j</Usuario>
      <IdOperacion>ESTABLECIMIENTOS_INSERTAR_V2</IdOperacion>
      <TipoRetorno>JSON</TipoRetorno>
      <Peticiones>
      ${Peticion}
      </Peticiones>                                               
    </Operacion>`;

      console.log("Peticion", Peticion);
      const respuesta = await axios.get(encodeURI(url));

      return respuesta;
    },
    async modificarCorto({ commit, state }, { ID, UrlCertificado, IdBarrio }) {
      const idOrigen = state.idOrigen;
      const Slug = state.slug;
      const url = `${RUTA}/${CONTEXTO}/Operaciones?xmlDoc=
      <Operacion>
      <IdCookie>9999999999</IdCookie>
      <IdCookieUsuario>9999999999</IdCookieUsuario>
      <TipoRetorno>JSON</TipoRetorno>
      <IdOperacion>ESTABLECIMIENTOS_MODIFICAR_CORTO</IdOperacion>
      <Peticiones>
         <Peticion Id="${ID}" IdBarrio="${IdBarrio}" Slug="${Slug}" Barrio="" Barrio2="" IdGoogle="" Lat="" Lng="" DireccionGoogle="" UrlImagen="" UrlDni="" UrlCertificado="${UrlCertificado}" UrlIAE="" IdComarca="" IdFormulario=""/>
      </Peticiones>
     
      </Operacion>`;

      const respuesta = await axios.get(encodeURI(url));

      return respuesta;
    },
    async consultarCompleto({ commit, state }, { ID, IDORIGEN }) {
      const idOrigen = state.idOrigen;
      const url = `${RUTA}/${CONTEXTO}/Operaciones?xmlDoc=
      <Operacion>
      <IdCookie>9999999999</IdCookie>
      <IdCookieUsuario>9999999999</IdCookieUsuario>
      <TipoRetorno>JSON</TipoRetorno>
      <IdOperacion>ESTABLECIMIENTO_OBTENERDATOS_COMPLETO</IdOperacion>
      <Peticiones>
          <Peticion IdOrigen="${IDORIGEN}" Id="${ID}"/>
      </Peticiones>
      </Operacion>`;

      const respuesta = await axios.get(encodeURI(url));

      return respuesta;
    },
    async comprobarEstablecimiento({ commit, state }, { CIF, EMail, IBAN }) {
      const url = `${RUTA}/${CONTEXTO}/Operaciones?xmlDoc=
      <Operacion>
       <IdCookie>9999999999</IdCookie>
       <IdCookieUsuario>9999999999</IdCookieUsuario>
       <TipoRetorno>JSON</TipoRetorno>
       <IdOperacion>ESTABLECIMIENTOS_OBTENER</IdOperacion>
       <Peticiones>
          <Peticion IdOrigen = "" DesdeFechaAlta = "" HastaFechaAlta = "" Validado = "S" CIF = "${CIF}" IAE = "" Municipio = "" DesdeFechaModificacion = "" HastaFechaModificacion = "" CodigoBono = "" Provincia="" IdCampanya="" />
       </Peticiones>
      </Operacion>`;

      const respuesta = await axios.get(encodeURI(url));
      console.log("rute", url, respuesta);
      return respuesta;
    },
    resetFormulario({ commit, state }) {
      commit("establecimientoActual", state.resetEstablecimiento);
      const resto = {
        UrlImagen: null,
        UrlCertificado: null,
        UrlDni: null,
        UrlIAE: null,
        SectorActividad: [],
        IAE: [],
        TipoBono: [],
      };
      Object.keys(resto).forEach((e) => {
        commit(e, resto[e]);
      });

      return "Hecho";
    },
    alta({ dispatch, commit, state }, datos) {
      const {
        IdFormulario,
        UrlImagen,
        UrlDni,
        UrlCertificado,
        UrlIAE,
        Nombre,
        Pais,
        Descripcion,
        Telefono,
        CP,
        Lat,
        Lng,
        DireccionGoogle,
        IdGoogle,
        Direccion,
        Poblacion,
        Provincia,
        Web,
        SectorActividad,
        RazonSocial,
        NumeroEmpleados,
        IAE,
        CIF,
        PersonaContacto,
        Cargo,
        EMail,
        NombreAsociacion,
        IBAN,
        Contacto,
      } = datos;
      const idOrigen = state.idOrigen;
      const miProvincia = state.bonoName.toUpperCase();
      const sinDatos = "0";
      const produccion = `https://webs.janto.es/Janto_KB/Operaciones?xmlDoc=<Operacion>
        <IdCookie>9999999092</IdCookie>
        <IdCookieUsuario>9999999092</IdCookieUsuario>
        <Usuario>j</Usuario>
        <IdOperacion>ESTABLECIMIENTOS_INSERTAR</IdOperacion>
        <TipoRetorno>JSON</TipoRetorno>
        <Peticiones>
        <Peticion IdOrigen = "3" IdFormulario="${IdFormulario}" Nombre="${Nombre}" RazonSocial="${RazonSocial}" Descripcion="${Descripcion}" SectorActividad ="${SectorActividad}" CIF = "${CIF}" NumeroEmpleados="${NumeroEmpleados}" IAE="${IAE}" PersonaContacto="${PersonaContacto}" Cargo="${Cargo}" Contacto = "${Contacto}" Telefono = "${Telefono}" EMail = "${EMail}" Web="${Web}" NombreAsociacion="${NombreAsociacion}" Direccion = "${Direccion}" CP = "${CP}" Provincia = "${Provincia}" Poblacion = "${Poblacion}" Pais = "España" IBAN = "${IBAN}" IdGoogle = "${IdGoogle}" Lat = "${Lat}" Lng = "${Lng}" DireccionGoogle = "${DireccionGoogle}" UrlImagen = "${UrlImagen}" UrlDni="${UrlDni}" UrlCertificado="${UrlCertificado}" UrlIAE="${UrlIAE}" />
        </Peticiones>
      </Operacion>`;

      const desarrollo = `https://webs.janto.es/Janto_KB/Operaciones?xmlDoc=<Operacion>
      <IdCookie>9999999999</IdCookie>
      <IdCookieUsuario>9999999999</IdCookieUsuario>
      <Usuario>j</Usuario>
      <IdOperacion>ESTABLECIMIENTOS_INSERTAR</IdOperacion>
      <TipoRetorno>JSON</TipoRetorno>
      <Peticiones>
      <Peticion IdOrigen = "${idOrigen}" IdFormulario="${BONO_ID}" Nombre="${Nombre}" RazonSocial="${RazonSocial}" Descripcion="${Descripcion}" SectorActividad ="${sinDatos}" CIF = "${CIF}" NumeroEmpleados="${NumeroEmpleados}" IAE="${sinDatos}" PersonaContacto="${PersonaContacto}" Cargo="${Cargo}" Contacto = "${Contacto}" Telefono = "${Telefono}" EMail = "${EMail}" Web="${Web}" NombreAsociacion="${NombreAsociacion}" Direccion = "${Direccion}" CP = "${CP}" Provincia = "${miProvincia}" Poblacion = "${Poblacion}" Pais = "España" IBAN = "${IBAN}" IdGoogle = "${IdGoogle}" Lat = "${Lat}" Lng = "${Lng}" DireccionGoogle = "${DireccionGoogle}" UrlImagen = "${UrlImagen}" UrlDni="${UrlDni}" UrlCertificado="${UrlCertificado}" UrlIAE="${UrlIAE}" />
      </Peticiones>
    </Operacion>`;

      const url = desarrollo;

      // cl*('alta url', url )
      // console.log('alta url', url )

      return axios.get(encodeURI(url)).then(async (res) => {
        const IdEstablecimiento =
          res.data.ESTABLECIMIENTOS_INSERTAR.Peticiones.Peticion.Retorno;
        const watos = {
          data: res.data,
        };
        console.log("mirarme id establecimiento", IdEstablecimiento);
        commit("idEstablecimientoActual", IdEstablecimiento);
        // const establecimientoActual = state.establecimientoActual
        // const SectorActividad = Array.isArray(establecimientoActual.SectorActividad) ? establecimientoActual.SectorActividad : [establecimientoActual.SectorActividad]
        // const IAES = Array.isArray(establecimientoActual.IAE) ? establecimientoActual.IAE : [establecimientoActual.IAE]
        // const TipoBono = Array.isArray(establecimientoActual.TipoBono) ? establecimientoActual.TipoBono : [establecimientoActual.TipoBono]
        const { SectorActividad, IAES, TipoBono } = datos.multi;
        watos.respuestaCampana = await dispatch("asignarCampana", {
          IdEstablecimiento,
        });
        watos.respuestaSectores = await dispatch("asignarSectores", {
          IdEstablecimiento,
          SectorActividad,
        });
        watos.respuestaIAE = await dispatch("asignarIAE", {
          IdEstablecimiento,
          IAES,
        });
        watos.respuestaBonos = await dispatch("asignarBonos", {
          IdEstablecimiento,
          TipoBono,
        });

        // dispatch('asignarCampana', idEstablecimiento).then(respuesta => {
        //   sectores.forEach(IdSectorActividad => dispatch('asignarSectores', { idEstablecimiento, IdSectorActividad }));
        //   datosIAE.forEach(IAE => dispatch('asignarIAE', { idEstablecimiento, IAE }));
        //   datosBonos.forEach(IdBono => dispatch('asignarIAE', { idEstablecimiento, IAE });

        // })

        /// console.log('res', res)
        console.log("queee", SectorActividad, IAES, TipoBono);
        console.log("Grabado", res.data, "datos", datos, "watos", watos);
        return res.data;
      });
    },
    gestionAlta: ({ state }, datos) => {
      const accion = "altas_bonoturismo";
      const miProvincia = state.bonoName.toUpperCase();
      const id = datos.IdFormulario;
      const cif = datos.CIF.toUpperCase();
      datos.Provincia = miProvincia;
      // const clave = id.toUpperCase()
      const clave = cif + "@" + miProvincia;
      return establecimientosRef
        .collection(accion)
        .doc(clave)
        .set(datos, { merge: true })
        .then((doc) => {
          console.log(
            "de vuelta ",
            doc,
            "id",
            id,
            "clave",
            clave,
            "datos",
            datos
          );
          return id;
        })
        .catch((err) => {
          console.log("error gestionAlta", err);
        });
    },
    asignarCampana: ({ state }, { IdEstablecimiento, bonos }) => {
      const bonox = {
        ORIGEN: 7,
        id_CAMPANA: 7,
      };
      let Peticion = `<Peticion IdEstablecimiento = "${IdEstablecimiento}" IdOrigen = "${bonox.ORIGEN}" IdCampanya="${bonox.id_CAMPANA}"/>`;

      // bonos.forEach(bono => Peticion += `<Peticion IdEstablecimiento = "${IdEstablecimiento}" IdOrigen = "${bonox.ORIGEN}" IdCampanya="${bonox.id_CAMPANA}"/>`)
      const url = `${RUTA}/${CONTEXTO}/Operaciones?xmlDoc=
      <Operacion>
          <IdCookie>9999999999</IdCookie>
          <IdCookieUsuario>9999999999</IdCookieUsuario>
          <IdOperacion>ESTABLECIMIENTOS_ASIGNAR_CAMPANYA</IdOperacion>
          <TipoRetorno>JSON</TipoRetorno>
          <Peticiones>
              ${Peticion}
          </Peticiones>
      </Operacion>`;

      // console.log('ASIGNAR')
      return axios.get(encodeURI(url));
      // return Peticion
    },
    asignarSectores: (
      { state, dispatch },
      { IdEstablecimiento, SectorActividad }
    ) => {
      console.log("Sector ACTIVIDAD", SectorActividad);
      let Peticion = "";
      SectorActividad.forEach(
        (item) =>
          (Peticion += `<Peticion IdEstablecimiento = "${IdEstablecimiento}" IdSectorActividad="${item.value}" SectorActividad="${item.label}"/>`)
      );

      const url = `${RUTA}/${CONTEXTO}/Operaciones?xmlDoc=
      <Operacion>
       <IdCookie>9999999999</IdCookie>
       <IdCookieUsuario>9999999999</IdCookieUsuario>
          <IdOperacion>ESTABLECIMIENTOS_ASIGNAR_SECTOR_ACTIVIDAD</IdOperacion>
          <TipoRetorno>JSON</TipoRetorno>
          <Peticiones>
              ${Peticion}
          </Peticiones>
      </Operacion>`;
      return axios.get(encodeURI(url));
      // return url
    },
    asignarIAE: ({ state }, { IdEstablecimiento, IAES }) => {
      let Peticion = "";

      IAES.forEach(
        (item) =>
          (Peticion += `<Peticion IdEstablecimiento = "${IdEstablecimiento}" IAE="${item.value}"/>`)
      );

      const url = `${RUTA}/${CONTEXTO}/Operaciones?xmlDoc=
      <Operacion>
       <IdCookie>9999999999</IdCookie>
       <IdCookieUsuario>9999999999</IdCookieUsuario>
          <IdOperacion>ESTABLECIMIENTOS_ASIGNAR_IAE</IdOperacion>
          <TipoRetorno>JSON</TipoRetorno>
          <Peticiones>
              ${Peticion}
          </Peticiones>                                  
      </Operacion>`;
      return axios.get(encodeURI(url));
      // return Peticion
    },
    asignarBonos: ({ state }, { IdEstablecimiento, TipoBono }) => {
      let Peticion = "";
      TipoBono.forEach(
        (item) =>
          (Peticion += `<Peticion IdEstablecimiento = "${IdEstablecimiento}" IdCampanya="${item.id_CAMPANA}" IdBono="${item.value}"/>`)
      );
      const url = `${RUTA}/${CONTEXTO}/Operaciones?xmlDoc=
      <Operacion>
        <IdCookie>9999999999</IdCookie>
        <IdCookieUsuario>9999999999</IdCookieUsuario>
        <IdOperacion>ESTABLECIMIENTOS_ASIGNAR_BONO</IdOperacion>
        <TipoRetorno>JSON</TipoRetorno>
        <Peticiones>
            ${Peticion}
        </Peticiones>                                  
      </Operacion>`;
      return axios.get(encodeURI(url));
      // return url
    },
    uploadImage: (
      { commit },
      { carpeta, tipo, nombre, fichero, fileName, extension, imageId }
    ) => {
      // cl*('aqui')
      commit("uploadingImage", true);
      commit("uploadProgress", null);

      const webId = "bonogv";

      if (!imageId) {
        return;
      }
      commit("currentUpload", null);
      const nombreWeb = "fv" + imageId + "@";
      const nombreConformado = nombreWeb + "_" + fileName;
      let DI = "nZzRXAVNa1WuBnxPsveNLwkg06R2";

      return firestorePro
        .auth()
        .signInWithEmailAndPassword("system@cms.janto.es", DI)
        .then((usuario) => {
          //  console.log('Usuario ', usuario, 'current', firestorePro.auth().currentUser)
          var storageRef = storage
            .ref()
            .child(carpeta)
            .child(webId)
            .child(imageId)
            .child(nombreConformado)
            .put(fichero)
            .then((doc) => {
              return doc.ref.getDownloadURL().then((downloadURL) => {
                const imgUrl = downloadURL;
                commit(nombre, imgUrl);
                commit("currentUpload", downloadURL);
                commit("uploadProgress", 100);
                commit("uploadingImage", false);
                return downloadURL;
              });
            });
          return storageRef.on("state_changed", function(snapshot) {
            //  console.log('nombre conformado', nombreConformado, 'FIREBASE User', firebase.auth().currentUser,'firebase prp', firestorePro.auth())
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            // state.uploadProgress = progress
            commit("uploadProgress", progress);

            //  console.log('Upload is ' + progress + '% done')
            //  console.log('Uploaded a blob or file!');
            if (progress == 100) {
              // return storageRef.snapshot.ref.getDownloadURL().then(downloadURL=>{
              //   const imgUrl = downloadURL
              //   commit(nombre, imgUrl)
              //   commit('currentUpload', downloadURL)
              //   commit('uploadProgress', 100)
              //   commit('uploadingImage', false)
              //   return downloadURL
              // })
            }
          });
        })
        .then((res) => {
          // cl*('res', res,)
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // ...
        });
    },
    getBono: ({ commit, state }, bono) => {
      const config = state.config;
      const bonoIdActual = !bono ? BONO_ID : config[bono];
      if (config[bono]) {
        commit("bonoName", bono);
      } else {
        commit("bonoName", "home");
      }

      const url = `https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents/bonos/${bonoIdActual}`;
      // const LITERALES_URL = `https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents/bonos/${BONO_ID}/literales/locale`

      return axios
        .get(url)
        .then((res) => FireStoreParser(res.data))
        .then((json) => {
          const webData = json.fields;
          commit("bonoActual", webData);

          return webData;
        });
    },
  },
  modules: {},
});
